import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { LabelsApi } from '@core/api/labels/labels.api';
import { MaintenancesApi } from '@core/api/maintenances/maintenances.api';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { QuotationService } from 'app/main/quotations/services/quotation.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { sentry } from 'sentry';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var LabelSelectorComponent = /** @class */ (function () {
    function LabelSelectorComponent(labelsApi, maintenancesApi, quotationApi, progressBar, fuseTranslationLoaderService) {
        this.labelsApi = labelsApi;
        this.maintenancesApi = maintenancesApi;
        this.quotationApi = quotationApi;
        this.progressBar = progressBar;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.associatedLabels = [];
        this.wasUpdatedLabels = new EventEmitter();
        this.labels = [];
        this.currentOffset = 0;
        this.hasMoreLabels = true;
        this.unsubscribeAll = new Subject();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    LabelSelectorComponent.prototype.ngOnInit = function () {
        this.fetchLabels();
    };
    LabelSelectorComponent.prototype.fetchLabels = function () {
        var _this = this;
        try {
            this.labelsApi
                .getLabels({ type: this.type }, this.currentOffset)
                .pipe(takeUntil(this.unsubscribeAll))
                .subscribe(function (result) {
                var newLabels = result.items;
                if (newLabels.length > 0) {
                    _this.labels = _this.labels.concat(newLabels);
                    _this.currentOffset += 50;
                    _this.fetchLabels();
                }
                else {
                    _this.hasMoreLabels = false;
                }
            });
        }
        catch (err) {
            sentry.captureException(err);
        }
    };
    LabelSelectorComponent.prototype.isSelectedLabel = function (labelId) {
        return !!this.associatedLabels.find(function (label) { return label && label.id === labelId; });
    };
    LabelSelectorComponent.prototype.addRemoveLabel = function (checkbox, label) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var labelIndex;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (checkbox.checked) {
                            this.associatedLabels.push(label);
                        }
                        else {
                            labelIndex = this.associatedLabels.findIndex(function (item) { return item.id === label.id; });
                            this.associatedLabels.splice(labelIndex, 1);
                        }
                        return [4 /*yield*/, this.saveLabel(label, !checkbox.checked)];
                    case 1:
                        _a.sent();
                        this.wasUpdatedLabels.emit(true);
                        return [2 /*return*/];
                }
            });
        });
    };
    LabelSelectorComponent.prototype.saveLabel = function (label, isRemove) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var input;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.progressBar.show();
                        input = {
                            labelId: label.id
                        };
                        if (!(this.type === 'maintenance')) return [3 /*break*/, 2];
                        input.maintenanceId = this.maintenanceId;
                        return [4 /*yield*/, this.maintenancesApi.saveMaintenanceLabel(input, isRemove)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        input.quotationId = this.quotationId;
                        return [4 /*yield*/, this.quotationApi.saveQuotationLabels(input, isRemove)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.progressBar.hide();
                        return [2 /*return*/];
                }
            });
        });
    };
    LabelSelectorComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    };
    return LabelSelectorComponent;
}());
export { LabelSelectorComponent };
